"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replyToMessage = void 0;
exports.replyToMessage = function (messageEvent, payload) {
    var origin = messageEvent.origin, source = messageEvent.source, data = messageEvent.data;
    source.postMessage({
        messageId: data.messageId,
        payload: payload,
    }, origin);
};
//# sourceMappingURL=replyToMessage.js.map